"use client";

import { useLanguage } from "../i18n/LanguageProvider";
import { ARTIKEL_TERBARU } from "../(halaman)/edukasi-kesehatan/artikel";

import { useCallback, useEffect, useRef, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import MenuBagikan from "./MenuBagikan";

/* ============================================================
   ARTICLE CAROUSEL

   >>> SELURUH ISI ARTIKEL DI BAWAH ADALAH DUMMY. <<<

   Judul, tanggal, dan ringkasannya karangan untuk keperluan tampilan.
   JANGAN TAYANGKAN apa adanya.

   Khusus untuk situs rumah sakit, ringkasan artikel kesehatan adalah
   informasi medis. Ringkasan dummy yang terdengar meyakinkan lebih
   berbahaya daripada kolom kosong: pengunjung menganggapnya nasihat
   resmi dari RS JMC. Karena itu ringkasan di bawah sengaja ditulis
   sangat umum - tidak ada angka, dosis, atau anjuran tindakan.

   Nantinya data ini sebaiknya datang dari CMS atau folder konten,
   bukan array statis di sini.

   ============================================================
   PERUBAHAN: KONTROL DI PONSEL

   TIDAK ADA AUTOPLAY di komponen ini, dan tidak pernah ada. Yang
   sebelumnya terjadi: kedua tombol panah diberi `hidden ... md:block`,
   jadi di ponsel tombolnya disembunyikan dan satu-satunya cara
   menggeser adalah usap jari.

   Alasannya masuk akal - di layar sentuh, usap memang lebih alami -
   tapi masalahnya nyata: tanpa tombol maupun indikator, tidak ada apa
   pun yang memberi tahu bahwa masih ada kartu di sebelah kanan.

   Sekarang ada DUA set kontrol, masing-masing untuk konteksnya:

     md ke atas  : panah melayang di sisi kiri dan kanan, seperti
                   sebelumnya. Ruang di samping carousel memang kosong,
                   jadi panah di situ tidak mengganggu apa pun.

     di bawah md : baris kontrol DI BAWAH carousel, berisi panah kiri,
                   indikator posisi, dan panah kanan. Panah melayang
                   tidak dipakai di ponsel karena ia akan menutupi
                   gambar kartu dan bertabrakan dengan tombol bagikan
                   di pojok kanan atas.

   Keduanya memanggil fungsi yang sama, jadi perilakunya tidak mungkin
   menyimpang.

   PERBEDAAN PERLAKUAN SAAT NONAKTIF, dan ini disengaja:
     panah melayang    : MENGHILANG di ujung. Panah mengambang yang bisa
                         ditekan tapi diam membuat orang mengira macet.
     panah di baris    : TETAP TERLIHAT tapi diredupkan. Di dalam baris
                         kontrol, tombol yang hilang membuat baris itu
                         berubah lebar dan indikatornya melompat.

   INDIKATOR POSISI bukan titik-titik, melainkan batang yang panjang dan
   letaknya mengikuti proporsi area yang terlihat terhadap seluruh
   lebar. Dengan lima artikel dan lebar kartu yang berubah tiap
   breakpoint, jumlah "halaman" tidak tetap - titik-titik akan berbohong
   soal ada berapa langkah tersisa.
   ============================================================ */

/* ISI ARTIKEL DISIMPAN PER BAHASA DI SINI, BUKAN DI dictionary.js.

   Ini keputusan yang berbeda dari komponen lain, dan alasannya:

   dictionary.js berisi ANTARMUKA - label tombol, judul section, teks
   pembaca layar. Isinya tetap dan jumlahnya terbatas.

   Artikel adalah KONTEN. Jumlahnya bertambah terus, dan cepat atau
   lambat ia akan datang dari CMS atau basis data, bukan dari berkas
   kode. Menaruhnya di kamus berarti dua hal buruk: kamus membengkak
   tiap ada artikel baru, dan seluruh pekerjaan itu terbuang begitu
   CMS masuk.

   Dengan bentuk { id, en } di sini, strukturnya sudah sama dengan yang
   nanti dibutuhkan di basis data - satu baris artikel dengan kolom
   judul_id dan judul_en. Jadi pemindahannya nanti tinggal menyalin.

   BOLEH JUGA DIISI STRING BIASA. Kalau suatu judul memang sama di
   kedua bahasa (misalnya "Medical Check Up"), tulis saja
   title: "Medical Check Up" - fungsi pilihTeks di bawah menerima
   keduanya. Kalau `en` kosong atau tidak ada, versi Indonesia yang
   dipakai, jadi artikel baru tidak akan pernah tampil bolong. */
/* ============================================================
   DAFTAR ARTIKEL DIAMBIL DARI app/edukasi-kesehatan/artikel.js

   Sebelumnya berkas ini menyimpan daftarnya sendiri - lima entri
   "GANTI: judul artikel kesehatan pertama" dan seterusnya. Akibatnya
   ada DUA daftar artikel di project: satu di sini untuk kartu di
   beranda, satu lagi di artikel.js untuk halaman isinya.

   Dua daftar berarti dua pekerjaan setiap kali ada artikel baru, dan
   yang lebih buruk: keduanya bisa menyimpang tanpa ketahuan. Kartu di
   beranda menampilkan satu judul, halaman yang dibuka menampilkan
   judul lain - dan tidak ada error yang muncul untuk memberi tahu.

   Sekarang satu sumber. Menambah artikel cukup di artikel.js, dan
   kartunya muncul sendiri di beranda.

   Diambil 5 terbaru. Carousel dengan lebih dari itu jarang digulir
   sampai habis; sisanya ada di halaman daftar lengkap.
   ============================================================ */
const ARTICLES = ARTIKEL_TERBARU.slice(0, 5);



const ARTICLE_BASE = "/edukasi-kesehatan";

/* Formatter dibuat SEKALI di luar komponen, dengan timeZone eksplisit.

   Tanpa timeZone, server (biasanya UTC) dan browser pengguna bisa
   menghasilkan tanggal berbeda, dan React akan melaporkan hydration
   mismatch. Menguncinya ke Asia/Jakarta membuat hasilnya sama di
   kedua sisi. */
/* Formatter jadi FUNGSI karena locale-nya sekarang ikut bahasa. Nama
   hari dan bulan berbeda di tiap bahasa, dan "Sen, 28 Jul 2026" tidak
   berarti apa-apa bagi pembaca Inggris.

   timeZone tetap dikunci ke Asia/Jakarta - itu yang menjaga hasil
   render peladen (biasanya UTC) dan browser tetap sama, sehingga tidak
   memicu hydration mismatch. */
const buatDateFormat = (lang) =>
  new Intl.DateTimeFormat(lang === "en" ? "en-GB" : "id-ID", {
    weekday: "long",
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Jakarta",
  });

/* Menerima { id, en } maupun string biasa. Urutan cadangannya:
   bahasa aktif -> Bahasa Indonesia -> string kosong. */
function pilihTeks(nilai, lang) {
  if (nilai == null) return "";
  if (typeof nilai === "string") return nilai;
  return nilai[lang] || nilai.id || "";
}

export default function ArticleCarousel() {
  const { lang, t } = useLanguage();
  const DATE_FORMAT = buatDateFormat(lang);

  const trackRef = useRef(null);
  const cardRefs = useRef([]);

  /* Satu objek state, bukan empat state terpisah. Keempat nilai ini
     selalu berubah bersamaan pada peristiwa scroll yang sama; memisahnya
     hanya menambah render tanpa manfaat. */
  const [nav, setNav] = useState({
    atStart: true,
    atEnd: false,
    thumbWidth: 100,
    thumbLeft: 0,
  });

  /* Status dibaca dari posisi scroll, bukan dari index yang disimpan
     sendiri. Scroll bisa dipicu jari, roda mouse, atau tombol - kalau
     statusnya hanya diubah tombol, panah akan salah menonaktifkan diri
     setelah pengguna menggeser dengan jari. */
  const syncEdges = useCallback(() => {
    const track = trackRef.current;
    if (!track) return;

    const max = track.scrollWidth - track.clientWidth;

    /* Toleransi 4px. Browser sering berhenti di 0,5px dari ujung karena
       pembulatan pecahan piksel; tanpa toleransi, panah tidak pernah
       menonaktifkan diri di ujung kanan. */
    const atStart = track.scrollLeft <= 4;
    const atEnd = max <= 0 || track.scrollLeft >= max - 4;

    /* Lebar batang indikator = porsi yang terlihat terhadap total.
       Posisinya = seberapa jauh sudah tergeser. Keduanya persen, jadi
       ikut benar berapa pun lebar layarnya. */
    const ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
    const thumbWidth = Math.min(100, Math.max(12, ratio * 100));
    const thumbLeft =
      max <= 0 ? 0 : (track.scrollLeft / max) * (100 - thumbWidth);

    setNav({ atStart, atEnd, thumbWidth, thumbLeft });
  }, []);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    syncEdges();
    track.addEventListener("scroll", syncEdges, { passive: true });
    window.addEventListener("resize", syncEdges);
    return () => {
      track.removeEventListener("scroll", syncEdges);
      window.removeEventListener("resize", syncEdges);
    };
  }, [syncEdges]);

  /* Geser sejauh satu kartu.

     PERBAIKAN: langkahnya diukur dari selisih offsetLeft antara kartu
     pertama dan kedua, bukan offsetWidth ditambah angka gap yang
     ditulis manual.

     Versi sebelumnya memakai `card.offsetWidth + 16`, padahal track
     memakai gap-4 di ponsel (16px) dan md:gap-6 di desktop (24px). Di
     desktop tiap tekan meleset 8px, dan setelah beberapa kali tekan
     kartunya berhenti tidak lagi rata dengan tepi. Selisih offsetLeft
     sudah termasuk gap berapa pun nilainya. */
  const scrollByCard = (direction) => {
    const track = trackRef.current;
    const cards = cardRefs.current.filter(Boolean);
    if (!track || cards.length === 0) return;

    const step =
      cards.length > 1
        ? cards[1].offsetLeft - cards[0].offsetLeft
        : cards[0].offsetWidth;

    track.scrollBy({ left: direction * step, behavior: "smooth" });
  };

  /* Tombol panah kiri-kanan pada keyboard. Track diberi tabIndex 0 agar
     bisa dijangkau lewat Tab - wilayah yang bisa di-scroll memang harus
     bisa dicapai keyboard, kalau tidak, isinya di luar layar jadi tidak
     terjangkau tanpa tetikus. */
  const onKeyDown = (e) => {
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      scrollByCard(-1);
    }
    if (e.key === "ArrowRight") {
      e.preventDefault();
      scrollByCard(1);
    }
  };

  return (
    <div className="relative">
      <div
        ref={trackRef}
        tabIndex={0}
        onKeyDown={onKeyDown}
        role="group"
        aria-label={t("artikel.trackAria")}
        className="flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 [-ms-overflow-style:none] [scrollbar-width:none] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--c-brand-mid)] [&::-webkit-scrollbar]:hidden md:gap-6"
      >
        {ARTICLES.map((article, i) => (
          <div
            key={article.slug}
            ref={(el) => (cardRefs.current[i] = el)}
            className="w-[82%] shrink-0 snap-start sm:w-[60%] md:w-[46%] lg:w-[36%] xl:w-[27%]"
          >
            <ArticleCard article={article} dateFormat={DATE_FORMAT} lang={lang} t={t} />
          </div>
        ))}
      </div>

      {/* ---------- PANAH MELAYANG, md ke atas ---------- */}
      <button
        type="button"
        onClick={() => scrollByCard(-1)}
        disabled={nav.atStart}
        aria-label={t("artikel.sebelumnya")}
        className="absolute -left-3 top-[30%] z-10 hidden -translate-y-1/2 rounded-full bg-[var(--c-surface)] p-3 text-[var(--c-brand-strong)] shadow-lg ring-1 ring-[var(--c-line)] transition hover:bg-slate-50 disabled:pointer-events-none disabled:opacity-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--c-brand-mid)] md:block"
      >
        <Chevron direction="left" />
      </button>

      <button
        type="button"
        onClick={() => scrollByCard(1)}
        disabled={nav.atEnd}
        aria-label={t("artikel.berikutnya")}
        className="absolute -right-3 top-[30%] z-10 hidden -translate-y-1/2 rounded-full bg-[var(--c-surface)] p-3 text-[var(--c-brand-strong)] shadow-lg ring-1 ring-[var(--c-line)] transition hover:bg-slate-50 disabled:pointer-events-none disabled:opacity-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--c-brand-mid)] md:block"
      >
        <Chevron direction="right" />
      </button>

      {/* ---------- BARIS KONTROL, di bawah md ----------
         Tombolnya 44x44px, ambang minimum target sentuh yang lazim
         dipakai. Ukuran itu yang menentukan p-3 di bawah, bukan selera. */}
      <div className="mt-5 flex items-center gap-4 md:hidden">
        <button
          type="button"
          onClick={() => scrollByCard(-1)}
          disabled={nav.atStart}
          aria-label={t("artikel.sebelumnya")}
          className="shrink-0 rounded-full bg-[var(--c-surface)] p-3 text-[var(--c-brand-strong)] shadow-sm ring-1 ring-[var(--c-line)] transition active:bg-slate-100 disabled:pointer-events-none disabled:opacity-30 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--c-brand-mid)]"
        >
          <Chevron direction="left" />
        </button>

        {/* Indikator posisi. aria-hidden karena informasi yang sama sudah
           tersedia lewat status aktif/nonaktif kedua tombol di sampingnya
           - membacakan batang ini lagi hanya menambah kebisingan. */}
        <div aria-hidden="true" className="relative h-1 flex-1 overflow-hidden rounded-full bg-slate-200">
          <span
            className="absolute inset-y-0 rounded-full bg-[var(--c-brand)] transition-all duration-200 ease-out motion-reduce:transition-none"
            style={{ width: `${nav.thumbWidth}%`, left: `${nav.thumbLeft}%` }}
          />
        </div>

        <button
          type="button"
          onClick={() => scrollByCard(1)}
          disabled={nav.atEnd}
          aria-label={t("artikel.berikutnya")}
          className="shrink-0 rounded-full bg-[var(--c-surface)] p-3 text-[var(--c-brand-strong)] shadow-sm ring-1 ring-[var(--c-line)] transition active:bg-slate-100 disabled:pointer-events-none disabled:opacity-30 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--c-brand-mid)]"
        >
          <Chevron direction="right" />
        </button>
      </div>
    </div>
  );
}

/* ============================================================
   ARTICLE CARD
   ============================================================ */

/* dateFormat dan t DITERUSKAN SEBAGAI PROP, tidak dibaca dari lingkup
   modul. Sebelumnya DATE_FORMAT adalah konstanta modul sehingga
   komponen ini bisa memakainya langsung; begitu ia bergantung pada
   bahasa, ia harus dibuat di dalam komponen induk dan diturunkan.

   Alternatifnya memanggil useLanguage() lagi di sini - juga sah, tapi
   satu sumber di induk lebih mudah ditelusuri. */
function ArticleCard({ article, dateFormat, lang, t }) {
  const judul = pilihTeks(article.judul, lang);
  const href = `${ARTICLE_BASE}/${article.slug}`;

  return (
    <article className="group relative flex h-full flex-col overflow-hidden rounded-2xl bg-[var(--c-surface)] ring-1 ring-[var(--c-line)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_1px_2px_rgba(15,23,42,0.12),0_16px_32px_-12px_rgba(15,23,42,0.22)] hover:ring-[var(--c-brand-line)] motion-reduce:transform-none">

      {/* overflow-hidden di sini, bukan hanya di kartu: tanpa itu,
         gambar yang membesar saat hover akan meluber menutupi teks. */}
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-[var(--c-line-soft)]">
        <Image
          src={article.gambar}
          fill
          /* Empat tingkat, mengikuti lebar kartu di tiap breakpoint. */
          sizes="(max-width: 639px) 82vw, (max-width: 767px) 60vw, (max-width: 1023px) 46vw, (max-width: 1279px) 36vw, 27vw"
          alt={pilihTeks(article.gambarAlt, lang)}
          className="object-cover transition-transform duration-500 ease-out group-hover:scale-[1.06] motion-reduce:transform-none"
        />

        {/* MENU BAGIKAN.

           z-20 supaya berada di atas area ::after milik tautan judul
           yang menutupi seluruh kartu. Menunya sendiri dirender ke
           document.body lewat portal - lihat catatan di
           MenuBagikan.jsx soal tiga lapis overflow yang akan
           memotongnya kalau dirender di sini. */}
        <div className="absolute right-3 top-3 z-20">
          <MenuBagikan
            url={href}
            judul={judul}
            lang={lang}
            kelasTombol="h-10 w-10 bg-white/95 shadow-md backdrop-blur-sm hover:bg-white"
          />
        </div>
      </div>

      <div className="flex flex-1 flex-col p-4 sm:p-5 md:p-6">
        {/* <time> dengan dateTime memberi tanggal dalam format yang bisa
           dibaca mesin - berguna untuk SEO dan pembaca layar, terpisah
           dari teks yang ditampilkan ke manusia. */}
        <time dateTime={article.tanggal} className="mb-2 text-xs text-[var(--c-muted)] sm:mb-2.5 sm:text-[13px] md:text-sm">
          {dateFormat.format(new Date(article.tanggal))}
        </time>

        {/* line-clamp menjaga tinggi kartu tetap seragam meski panjang
           judul berbeda-beda. */}
        <h3 className="mb-2.5 line-clamp-3 text-[15px] font-bold leading-snug text-[var(--c-ink)] transition-colors duration-200 group-hover:text-[var(--c-brand)] sm:mb-3 sm:text-base md:text-lg">
          {/* Tautan membungkus judul dan diberi ::after absolut, sehingga
             SELURUH kartu bisa diklik tanpa membungkus kartu dalam <a>.
             Membungkus seluruh kartu akan membuat pembaca layar
             membacakan tanggal, judul, dan ringkasan sebagai satu nama
             tautan yang sangat panjang. */}
          <Link
            href={href}
            className="after:absolute after:inset-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--c-brand-mid)]"
          >
            {judul}
          </Link>
        </h3>

        <p className="mb-4 line-clamp-3 text-[13px] leading-relaxed text-[var(--c-body)] sm:mb-5 sm:text-sm md:text-[15px]">
          {pilihTeks(article.ringkas, lang)}
        </p>

        {/* mt-auto mendorong baris ini ke dasar kartu, jadi posisinya
           rata meski panjang judul dan ringkasan berbeda. aria-hidden
           karena tautan sebenarnya sudah ada di judul - tanpa ini,
           pembaca layar mendengar dua tautan ke halaman yang sama. */}
        <span aria-hidden="true" className="mt-auto inline-flex items-center gap-2 text-[13px] font-bold text-[var(--c-brand)] sm:text-sm md:text-base">
          {t("artikel.baca")}
          {/* Panah bergeser saat hover. Dianimasikan terpisah dari teksnya
             supaya teks tetap diam dan tetap enak dibaca. */}
          <span className="transition-transform duration-300 group-hover:translate-x-1 motion-reduce:transform-none">
            &rarr;
          </span>
        </span>
      </div>
    </article>
  );
}

function Chevron({ direction }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className="h-5 w-5">
      <path
        d={direction === "left" ? "M15 18l-6-6 6-6" : "M9 18l6-6-6-6"}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
